/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class StockEnquiryBOMEditor extends _Ext.GridEditorBase<StockItemBOMRow> {
        protected getColumnsKey() { return "Stock.StockEnquiryBOM"; } 
        protected getLocalTextPrefix() { return StockItemBOMRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            grid.setSelectionModel(new Slick.RowSelectionModel());


            return grid;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            //set selected row line no and BOM selection
            this.slickGrid.setSelectedRows([row]);

            var item = this.itemAt(row);
            (this.parentDialog as Inventory.StockEnquiryDialog).setbomvalues(item);

            var target = $(e.target);

            // if user clicks "i" element, e.g. icon

            this.view.refresh();

        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        public setdata(bomdetails: any[]) {
            this.view.setItems([]);

            
            for (let Itemdetail of bomdetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }
        public setselectedrow() {

            this.slickGrid.setSelectedRows(0);
        }
    }
}